module.exports = __webpack_public_path__ + "static/img/scBanner.e4a75da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/scBanner.jpg
// module id = rZ1H
// module chunks = 1